import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { useParams, Link } from "react-router-dom";
import cookie from "js-cookie";
import ExportJsonExcel from "js-export-excel";
import Sidebar from "../../partials/aside/Sidebar";
import categoryUserSitePublisherAction from "../../../store/actions/categoryUserSitePublisher";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import typeActionCategoryUserSitePublisher from "../../../store/actions/typeActionCategoryUserSitePublisher";
import actionCookie from "../../../helpers/action-cookie";
import TitleBar from "../../partials/content/TitleBar";
import CategorySitePublisherTopic from "./CategorySitePublisherTopic";
import ListCategoryUserSitePublisher from "./ListCategoryUserSitePublisher";
import UserExample from "../user/UserExample";
import ButtonDisable from "../../partials/other/ButtonDisable";
import ListSitePublisher from "./ListSitePublisher";
import ExportFileExcelButton from "./ExportFileExcelButton";
import PreviewPositionsGroupSitePublisher from "./PreviewPositionsGroupSitePublisher";

function EditGroupPublisher({
  dataSitePublisher,
  setPositionsForEdit,
  setTypeAction,
  setDates,
}) {
  const checkSitePublisherThatHasUserCategory = (
    userCategory,
    sitePublisherCategories
  ) => {
    if (sitePublisherCategories.includes(userCategory)) {
      return true;
    }
    return false;
  };

  const removeSitePublisherThatHasUserCategory = (listSitePublisher) => {
    return listSitePublisher.filter((sitePublisher) => {
      if (
        !checkSitePublisherThatHasUserCategory(
          UserExample.category,
          sitePublisher.categories
        )
      ) {
        return sitePublisher;
      }
    });
  };

  const [sitePublishers, setSitePublishers] = useState(() => {
    return removeSitePublisherThatHasUserCategory(ListSitePublisher);
  });

  const [categoryUserSitesPublisherData, setCategoryUserSitesPublisherData] =
    useState();
  const [categorySitePublisherSelected, setCategorySitePublisherSelected] =
    useState(0);
  const [searchInputText, setSearchInputText] = useState("");
  const [message, setMessage] = useState();
  useEffect(() => {
    setSitePublishers(
      removeSitePublisherThatHasUserCategory(getSitePublisherFromSearchInputs())
    );
  }, [searchInputText, categorySitePublisherSelected]);

  const getSitePublisherFromSearchInputs = () => {
    const sitePublisherThatHasSearchURL = getSitePublisherThatHasSearchURL();
    const sitePublisherThatHasCategorySelected =
      getSitePublisherThatHasCategorySelected();

    const sitePublisherSearch = [];
    for (const sitePublisherThatHasSearchURLItem of sitePublisherThatHasSearchURL) {
      for (const sitePublisherThatHasCategorySelectedItem of sitePublisherThatHasCategorySelected) {
        if (
          sitePublisherThatHasSearchURLItem.id ==
          sitePublisherThatHasCategorySelectedItem.id
        ) {
          sitePublisherSearch.push(sitePublisherThatHasSearchURLItem);
        }
      }
    }

    return sitePublisherSearch;
  };

  const getSitePublisherThatHasCategorySelected = () => {
    if (categorySitePublisherSelected == "0") {
      return ListSitePublisher;
    }
    return ListSitePublisher.filter((sitePublisher) => {
      if (sitePublisher.categories.includes(categorySitePublisherSelected)) {
        return sitePublisher;
      }
    });
  };

  const getSitePublisherThatHasSearchURL = () => {
    return ListSitePublisher.filter((sitePublisher) => {
      if (sitePublisher.url.includes(searchInputText)) {
        return sitePublisher;
      }
    });
  };

  const previousPageUrl = cookie.get(actionCookie.PREVIOUS_PAGE_URL);

  const checkPreviousPageUrlIsAllPageSitePublishers = () => {
    if (
      previousPageUrl.includes("/publishers/") &&
      previousPageUrl.includes("/all-page")
    ) {
      return true;
    }
    return false;
  };
  setTypeAction({
    type_action: typeActionCategoryUserSitePublisher.EDIT,
  });

  const generateTagSitesPublisher = () => {
    return sitePublishers.map((sitePublisher, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>
            <a href={sitePublisher.url} target="_blank">
              {sitePublisher.url}
            </a>
          </td>
          <td>{sitePublisher.categories.join(" - ")}</td>
          <td>
            <Link
              to={`/publishers/${sitePublisher.id}/all-page/${categorySitePublisherID}`}
              className="btn btn-info"
            >
              نمایش صفحات
            </Link>
          </td>
        </tr>
      );
    });
  };

  const params = useParams();
  const categorySitePublisherID = params.id;

  useEffect(() => {
    let categoryUserSitePublisher = ListCategoryUserSitePublisher.filter(
      (item) => item.id == categorySitePublisherID
    );
    categoryUserSitePublisher = categoryUserSitePublisher[0];
    setCategoryUserSitesPublisherData(categoryUserSitePublisher);

    setDates({
      name_category: categoryUserSitePublisher.name,
      start_date: categoryUserSitePublisher.start_date,
      end_date: categoryUserSitePublisher.end_date,
    });
    if (Object.keys(categoryUserSitePublisher).length !== 0) {
      if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
        setPositionsForEdit({
          dataSitePublisher: categoryUserSitePublisher.sites,
        });
      }
    }
  }, []);

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const generateCategorySitePublisherTopic = () => {
    return CategorySitePublisherTopic.map((category) => {
      if (category.id != UserExample.category_id) {
        return <option>{category.title}</option>;
      }
    });
  };

  const exportReportExcel = () => {
    var option = {};
    const categoryUserSitePublisher = document
      .querySelector("#name")
      .value.trim();
    option.fileName = categoryUserSitePublisher;
    let dataExcelFile = [
      {
        one: "عنوان گروه ",
        two: document.getElementById("name").value.trim() + "",
      },
      {
        one: "مبلغ گروه ",
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceCategoryUserSitePublisher(dataSitePublisher)
          )
        ),
      },
      {
        one: "تاریخ شروع",
        two: helpersNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            categoryUserSitesPublisherData?.start_date
          )
        ),
        three: "تاریخ پایان",
        four: helpersNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            categoryUserSitesPublisherData?.end_date
          )
        ),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];
    for (let key in dataSitePublisher) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(
          dataSitePublisher[key]
        ),
        { one: "=======================", two: "=======================" },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherData
  ) => {
    let sitePublisherUrl = sitePublisherData.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherData)
          )
        ),
      },
    ];

    for (const key in sitePublisherData) {
      if (key === "url") {
        continue;
      }

      const item = sitePublisherData[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }
    return dataEachSitePublisherExcelFile;
  };

  const generatePageDataReportExportExcel = (sitePublisherData) => {
    return [
      {
        one: sitePublisherData.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(sitePublisherData.price)
        ),
      },
      { ...sitePublisherData.positions },
      {
        one: "",
        two: "",
      },
    ];
  };

  const getPriceSitePublisher = (sitePublisherData) => {
    let pricePage = 0;
    const newSitePublisherData = { ...sitePublisherData };

    for (const key in newSitePublisherData) {
      if (key == "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="ویرایش کردن گروه سایت های نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="add-group-site-publisher">
              <div className="text-left pb-2">
                <Link to="/publishers/all" className="btn btn-success">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}

              <form>
                <div className="form-group">
                  <label>نام گروه</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="نام گروه"
                    id="name"
                    defaultValue={categoryUserSitesPublisherData?.name}
                    required
                  />
                </div>
                <div className="form-group">
                  <div className="table-responsive pt-3">
                    <table className="table table-hilite">
                      <thead>
                        <tr>
                          <td className="text-nowrap">
                            ارزش یک شبانه روز گروه نمایش دهنده{" "}
                          </td>
                          <td>تاریخ شروع </td>
                          <td>تاریخ پایان </td>
                          <td> دریافت لیست گروه بنری </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className="px-2 letter-spacing-finance-number">
                              {dataSitePublisher &&
                                helpersNumbers.toPersianNum(
                                  helpersNumbers.toFormatFinanceNumber(
                                    getPriceCategoryUserSitePublisher(
                                      dataSitePublisher
                                    )
                                  )
                                )}
                            </span>
                            <span className="pr-2">تومان</span>
                          </td>
                          <td>
                            <span className="number-finance">
                              {categoryUserSitesPublisherData !== undefined ? (
                                helpersNumbers.toPersianNum(
                                  helpersTime.convertGregorianToJalali(
                                    categoryUserSitesPublisherData?.start_date
                                  )
                                )
                              ) : (
                                <></>
                              )}
                            </span>
                          </td>
                          <td>
                            <span className="number-finance">
                              {categoryUserSitesPublisherData !== undefined ? (
                                helpersNumbers.toPersianNum(
                                  helpersTime.convertGregorianToJalali(
                                    categoryUserSitesPublisherData?.end_date
                                  )
                                )
                              ) : (
                                <></>
                              )}
                            </span>
                          </td>
                          <td>
                            <span
                              className="btn btn-success"
                              onClick={exportReportExcel}
                            >
                              <span className="pl-2">
                                <i className="fa fa-file-excel"></i>
                              </span>
                              <span>خروجی فایل Excel</span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="form-group">
                  <div className="container-fluid p-0">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div>
                          <label>جستجو آدرس سایت</label>
                        </div>
                        <div>
                          <input
                            onKeyUp={(e) => {
                              setSearchInputText(e.target.value);
                            }}
                            className="form-control"
                            id="site"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div>
                          <div>
                            <label>انتخاب دسته بندی موضوع</label>
                          </div>
                          <div>
                            <select
                              id="categories-site-publishers"
                              className="form-control"
                              onChange={(e) => {
                                setCategorySitePublisherSelected(
                                  e.target.value
                                );
                              }}
                            >
                              <option value="0"> همه دسته بندی ها</option>
                              {generateCategorySitePublisherTopic()}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="table-responsive pt-3">
                        <table className="table table-hilite tbl-td-white-space table-hover">
                          <thead>
                            <tr>
                              <td>#</td>
                              <td>نمایش دهنده</td>
                              <td>دسته بندی موضوع</td>
                              <td>نمایش صفحات</td>
                            </tr>
                          </thead>
                          <tbody>{generateTagSitesPublisher()}</tbody>
                        </table>
                      </div>
                      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  "></div>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <ButtonDisable
                    buttonTagHtml={
                      <span className="btn btn-success opacity-50">
                        ویرایش کردن
                      </span>
                    }
                  />
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      <ExportFileExcelButton />
      <PreviewPositionsGroupSitePublisher />
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    render: state.categoryUserSitePublisher.render,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptyPositions: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.EMPTY_POSITION,
        payload: action,
      });
    },
    setPositionsForEdit: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_POSITION_FOR_EDIT,
        payload: action,
      });
    },
    setTypeAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_TYPE_ACTION,
        payload: action,
      });
    },
    resetPositionInEditAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_POSITION_IN_EDIT_ACTION,
        payload: action,
      });
    },
    resetDate: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_DATE,
        payload: action,
      });
    },
    setDates: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_DATE,
        payload: action,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditGroupPublisher);
